module.exports = __webpack_public_path__ + "img/img_65.c86ab66a.png";